<template>
  <section>
    <div class="mod-block">
      <h3 class="title">商品图片</h3>
      <el-form size="mini" class="mod-form" ref="form" :model="form">
        <el-form-item prop="imagesList" :rules="[{ validator: validateImg, trigger: 'blur'}]">
          <div class="mod-tips">*上传要求：需上传商品的正面图、反面图、侧面图各一张图片，上传格式为JPG、PNG，单张图片大小不得超过3M</div>
          <div class="mod-uploads">
            <mc-upload-single v-model="list[0]" topMsg="商品正面图" :accept="accept" @update="change"></mc-upload-single>
            <mc-upload-single v-model="list[1]" topMsg="商品侧面图" :accept="accept" @update="change"></mc-upload-single>
            <mc-upload-single v-model="list[2]" topMsg="商品背面图" :accept="accept" @update="change"></mc-upload-single>
            <mc-upload v-model="list2" :disabled="!list[0] || !list[1] || !list[2]" :accept="accept" @update="change"></mc-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getMod', 'getComData'],
    data () {
      return {
        form: {
          imagesList: []
        },
        baseURL: window.IPConfig.HOST ? (window.IPConfig.IP + ':' + window.IPConfig.HOST) : window.IPConfig.IP,
        accept: 'image/jpeg,image/jpg,image/png',
        list: [null, null, null],
        list2: []
      }
    },
    computed: {},
    methods: {
      // 必须上传‘正面图、反面图、侧面图’
      validateImg (rule, value, callback) {
        let imagesList = this.form.imagesList
        if (!imagesList[0] || !imagesList[1] || !imagesList[2]) {
          callback(new Error('请上传‘正面图、反面图、侧面图’'))
          return
        }
        callback()
      },
      change () {
        let imgList = [...this.list, ...this.list2]
        let ar = []
        imgList.forEach(item => {
          if (item) {
            ar.push({url: item})
          }
        })
        this.form.imagesList = ar
      },
      init () {
        let urlList = [];
        this.list = [];
        this.list2 = [];
        this.form.imagesList.forEach(item=>{
          urlList.push(item.url);
        })
        if (urlList && urlList.length > 2) {
          urlList.forEach((item, index) => {
            if (index < 3) {
              this.list.push(item)
            } else {
              this.list2.push(item)
            }
          })
        }
      }
    },
    mounted () {
      // 编辑
      let {editData} = this.getComData()
      if (editData.imagesList && editData.imagesList.length > 0) {
        this.form.imagesList = [].concat(editData.imagesList)
        this.init()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 20px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
  }
  .mod-tips {
    color: red;
    font-size: 12px;
  }
  .mod-uploads {
    overflow: hidden;
    .mc-upload-single {
      float: left;
      margin-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/standard/commodity-img.vue